import { useState } from "react";
import ImageBanner from "@/components/ImageBanner";
import Footer from "@/layout/Footer";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { authAction } from "@/redux/actions/auth.action";
import DesktopResetPasswordForm from "@/components/DesktopResetPasswordForm";
import MobileResetPasswordForm from "@/components/MobileResetPasswordForm";
import UseHandleBack from "@/hooks/UseHandleBack";
import PasswordChangedModal from "@/components/PasswordChangedModal";

const schema = Yup.object().shape({
	password: Yup.string()
		.required("Password is required")
		.min(8, "Password must be at least 8 characters")
		.matches(
			/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
			"Password must include uppercase, lowercase, number, and symbol"
		),

	confirmPassword: Yup.string()
		.required("Confirm Password is required")
		.oneOf([Yup.ref("password"), ""], "Passwords must match"),
});

const ResetPassword = () => {
	const forgotPassword = useSelector((state) => state.forgotPassword);
	console.log("Forgot Password State:", forgotPassword);
	const email = forgotPassword?.email || "";
	const code = forgotPassword?.code || "";
	const handleBack = UseHandleBack("/");

	const [resetPasswordError, setResetPasswordError] = useState(null);
	const [resetPasswordModal, setIsResetModalOpen] = useState(false);

	const navigate = useNavigate();
	const dispatch = useDispatch();
	const desktopForm = useForm({
		resolver: yupResolver(schema),
		mode: "onChange",
	});

	const desktopPassword = desktopForm.watch("password", "");
	const desktopConfirmPassword = desktopForm.watch("confirmPassword", "");

	const mobileForm = useForm({
		resolver: yupResolver(schema),
		mode: "onChange",
	});

	const mobilePassword = mobileForm.watch("password", "");
	const mobileConfirmPassword = mobileForm.watch("confirmPassword", "");

	const onSubmit = async (data) => {
		const resetPasswordData = { ...data, email: email, otp: code };
		console.log("Reset Password submitted:", data);
		try {
			const result = await dispatch(
				authAction.resetPassword(resetPasswordData)
			);

			if (result?.success) {
				//navigate("/login");
				console.log("Reset Password successful:", result);
				setIsResetModalOpen(true);
			} else {
				setResetPasswordError(result?.error || "Reset Password failed");
			}
		} catch (error) {
			//console.error("Reset Password failed:", error);
			setResetPasswordError(
				error?.error || error.message || "An unexpected error occurred"
			);
		}
	};

	return (
		<>
			<div className="relative flex flex-col hidden lg:flex w-full h-auto items-center justify-center mt-[40px]">
				<div className="w-full max-w-[1440px] flex items-center justify-between px-8">
					<ImageBanner
						type="desktop"
						title="Reset Your Password"
						containerWidth="w-full max-w-[1440px] flex items-center"
						titlePosition={{ top: "top-[100px]", left: "left-[60px]" }}
					/>
				</div>
			</div>
			<div className="flex justify-center mt-[28px] h-[800px] hidden lg:flex">
				<div className="w-[361px] h-auto flex flex-col items-center gap-[16px] rounded-[8px] pt-[16px] pr-[20px] pb-[32px] pl-[20px]">
					{resetPasswordError && (
						<div className="text-red-500 text-sm mb-4">
							{resetPasswordError}
						</div>
					)}
					<DesktopResetPasswordForm
						form={desktopForm}
						onSubmit={onSubmit}
						password={desktopPassword}
						confirmPassword={desktopConfirmPassword}
					/>
					<p
						className="text-[14px] font-[400] font-montserrat leading-[1] text-[#193D34] cursor-pointer mt-[40px]"
						onClick={handleBack}
					>
						Cancel
					</p>
				</div>
			</div>

			{/* Mobile View  */}
			<ImageBanner
				type="mobile"
				title={`Reset Your\n Password`}
				mobileTitlePosition={{ top: "top-[200px]", left: "left-[10px]" }}
			/>
			<div className="flex justify-center mt-[28px] h-[800px] block lg:hidden">
				<div className="w-[90%] max-w-[361px] h-auto flex flex-col items-center gap-[16px] rounded-[8px] pt-[16px] pr-[20px] pb-[32px] pl-[20px]">
					<MobileResetPasswordForm
						form={mobileForm}
						onSubmit={onSubmit}
						password={mobilePassword}
						confirmPassword={mobileConfirmPassword}
					/>
					<p className="text-[14px] font-[400] font-montserrat leading-[1] text-[#193D34] cursor-pointer mt-[40px]">
						Cancel
					</p>
				</div>
			</div>
			{resetPasswordModal && (
				<PasswordChangedModal
					onClose={() => {
						setIsResetModalOpen(false);
						navigate("/login");
					}}
				/>
			)}
			<Footer />
		</>
	);
};

export default ResetPassword;
